import { useFormikContext } from "formik";
import { Stack, TextField } from "@mui/material";
import { AddClientFormValues } from "../../types";

type AlignmentStyles = {
  flexWrap?: string;
  justifyContent?: string;
  alignContent?: string;
  direction?: string;
};

type Props = {
  alignmentStyles: AlignmentStyles;
};

const ClientOwnerDetails = ({ alignmentStyles }: Props) => {
  const { handleChange, values, errors, touched } =
    useFormikContext<AddClientFormValues>();

  return (
    <>
      <Stack
        sx={{
          ...alignmentStyles,
        }}
        data-testid="owner-details-fields"
      >
        <TextField
          id="main-user-first-name"
          label="First Name"
          variant="standard"
          sx={{ paddingBottom: "1%" }}
          autoComplete="disabled"
          value={values["main-user-first-name"]}
          onChange={handleChange}
          error={
            touched["main-user-first-name"] &&
            Boolean(errors["main-user-first-name"])
          }
          helperText={
            touched["main-user-first-name"] && errors["main-user-first-name"]
          }
        />
        <TextField
          id="main-user-last-name"
          label="Last Name"
          variant="standard"
          sx={{ paddingBottom: "1%" }}
          autoComplete="disabled"
          value={values["main-user-last-name"]}
          onChange={handleChange}
          error={
            touched["main-user-last-name"] &&
            Boolean(errors["main-user-last-name"])
          }
          helperText={
            touched["main-user-last-name"] && errors["main-user-last-name"]
          }
        />
        <TextField
          id="email"
          label="Email"
          variant="standard"
          sx={{ paddingBottom: "1%" }}
          autoComplete="disabled"
          value={values.email}
          onChange={handleChange}
          error={touched.email && Boolean(errors.email)}
          helperText={touched.email && errors.email}
        />
      </Stack>
    </>
  );
};

export default ClientOwnerDetails;
